var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "height": "auto",
      "width": "90%"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "pop-log-title"
  }, [_vm._v("Records(" + _vm._s(_vm.faceUidLogTotal ?? 0) + ")")]), _c('div', {
    staticClass: "pop-log-list"
  }, [_c('div', {
    ref: "myScroll",
    staticClass: "pop-log-box",
    on: {
      "scroll": _vm.checkScroll
    }
  }, [_c('div', {
    staticClass: "pop-log-item hd"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._v("Time (UTC)")]), _c('div', {
    staticClass: "row"
  }, [_vm._v("FACE ID")]), _c('div', {
    staticClass: "row"
  }, [_vm._v("TYPE")])]), _vm._l(_vm.faceUidLogList, function (item, index) {
    return _c('div', {
      staticClass: "pop-log-item"
    }, [_c('div', {
      staticClass: "row"
    }, [_vm._v(_vm._s(item.allocated_time.replace("T", " ").replace(".000Z", "")))]), _c('div', {
      staticClass: "row"
    }, [_vm._v(_vm._s(item.face_id))]), _c('div', {
      staticClass: "row"
    }, [item.face_status == 0 ? [_vm._v(" fail ")] : _vm._e(), item.face_status == 1 ? [_vm._v(" success ")] : _vm._e(), item.face_status == 2 ? [_vm._v(" fail-repeat ")] : void 0], 2)]);
  })], 2)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };